exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vcp-m-dashboard{z-index:11;position:absolute;left:0;bottom:0;width:100%;height:59px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.7)),to(transparent));background:linear-gradient(0deg,rgba(0,0,0,.7),transparent)}.fullscreen .vcp-m-dashboard{bottom:12px}.small .vcp-m-dashboard{height:49px}.settings-open .vcp-m-dashboard{display:block!important}.small .vcp-m-dashboard .vcp-controls{height:40px}", ""]);

// exports
